<template>
  <div class="col-sm-12 list-content result-table nopads">
      <vue3-datatable
          ref="resultTable"
          :rows="selectorData"
          :columns="fields"
          :pagination="false"
          :sticky-header="true"
          height="55vh"
          :sortable="true"
          skin="bh-table-compact"
          row-class="routa-table-row"
          cell-class="routa-table-cell"
          @row-click="openModal"
      >
          <template #vastaa="data">
              <div class="mb-2 button-column">
                  <button class="btn btn-sm btn-success ms-1 mb-1" @click.stop="openHarjaSubmitModal('vastaanotto', data.value)">
                      {{ $t('harja.receive') }}
                  </button>
                  <button class="btn btn-sm btn-secondary ms-1 mb-1" @click.stop="openHarjaSubmitModal('aloitus', data.value)">
                      {{ $t('harja.start') }}
                  </button>
                  <button class="btn btn-sm btn-primary ms-1 mb-1" @click.stop="openHarjaSubmitModal('muutos', data.value)">
                      {{ $t('harja.change') }}
                  </button>
                  <button class="btn btn-sm btn-info ms-1 mb-1" @click.stop="openHarjaSubmitModal('lopetus', data.value)">
                      {{ $t('harja.end') }}
                  </button>
                  <button class="btn btn-sm btn-dark ms-1 mb-1" @click.stop="openHarjaSubmitModal('vastaus', data.value)">
                      {{ $t('harja.answer') }}
                  </button>
              </div>
          </template>
      </vue3-datatable>
    <div
      v-if="loading"
      id="loader"
      class="spinner"
    />
  </div>
</template>

<script>

import {mapHelper} from "@/components/mixins/MapMixin";
import {restApi} from "@/components/mixins/RestApiMixin";
import {timeUtils} from "@/components/mixins/TimeUtils";
import Vue3Datatable from "@bhplugin/vue3-datatable";

export default {
    name: 'HarjaMessagesList',
    components: {Vue3Datatable},
    mixins: [mapHelper,restApi, timeUtils],
    props: {
        data: {
            type: Array,
            forms: [],
            return: []
        },
    },
    data() {
        return {
            loading: false,
            selectorData: null,
            modalData: null,
        }
    },
    computed: {
        fields() {
            return [
                {field: 'ilmoitustyyppi', title: this.$t('harja.notification_type'), sort: true, headerClass: 'routa-table-header'},
                {field: 'tila', title: this.$t('area_report.status'), sort: true, headerClass: 'routa-table-header'},
                {field: 'ilmoitettuFormated', title: this.$t('harja.notified'), sort: true, headerClass: 'routa-table-header'},
                {field: 'paikankuvaus', title: this.$t('harja.site_description'), sort: true, headerClass: 'routa-table-header'},
                {field: 'vastaa', title: this.$t('harja.receipt'), sort: false, headerClass: 'routa-table-header'},
            ]
        },
    },
    watch: {
      data: function (val) {
          this.selectorData = []
          val.forEach(dat => {
              dat.ilmoitus.ilmoitettuFormated = this.getDate(dat.ilmoitus.ilmoitettu)
              this.selectorData.push(
                  dat.ilmoitus)
          })
      }
    },
    methods: {
        openHarjaSubmitModal: function (type, data) {
            let id = data.ilmoitusid
            this.$emit('openHarjaModal', type, id)
        },
        close: function () {
            this.$emit('close')
        },
        openModal: function (data) {
            this.$emit('openModal', data)
        },
    }
}
</script>

<style scoped>
.button-column {
    min-width: 26em;
}
</style>
